import { render } from "./CountyDetails.vue?vue&type=template&id=fbbbd01c"
import script from "./CountyDetails.vue?vue&type=script&lang=ts"
export * from "./CountyDetails.vue?vue&type=script&lang=ts"
script.render = render

export default script